module.exports = __webpack_public_path__ + "img/banner-cocacola.14e0952f.png";